<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <ion-title>Change Password</ion-title>
        <ion-buttons slot="start">
          <ion-back-button href="/"></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-grid>
        <ion-row justify-content-center>
          <ion-col align-self-center size-md="6" size-lg="5" size-xs="12">
            <div padding>
              <ion-item>
                <ion-input
                  type="password"
                  :value="currentPassword"
                  ref="theCurrentPassword"
                  name="currentPassword"
                  placeholder="Current Password"
                ></ion-input>
              </ion-item>
              <ion-item>
                <ion-input
                  type="password"
                  :value="newPassword"
                  ref="theNewPassword"
                  name="newPassword"
                  placeholder="New Password"
                ></ion-input>
              </ion-item>
              <ion-item>
                <ion-input
                  type="password"
                  :value="confirmNewPassword"
                  ref="theConfirmNewPassword"
                  name="confirmNewPassword"
                  placeholder="Confirm New Password"
                ></ion-input>
              </ion-item>
            </div>
            <div padding>
              <ion-button size="large" @click="changePassword" expand="block"
                >Change Password</ion-button
              >
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </div>
</template>
<script>
import Repository from "../../repositories/RepositoryFactory";
var  AuthorizationRepository = Repository.get("authorization");

export default {
  currentPassword: "",
  newPassword: "",
  confirmNewPassword: "",
  data() {
    return {
      openAppointments: [],
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    };
  },
  methods: {
    changePassword: async function() {
      let self = this;
      this.currentPassword = this.$refs.theCurrentPassword.value;
      this.newPassword = this.$refs.theNewPassword.value;
      this.confirmNewPassword = this.$refs.theConfirmNewPassword.value;

      var changePassword = {
        UserName: this.$store.state.userName,
        OldPassword: this.currentPassword,
        Password: this.newPassword,
        ConfirmPassword: this.confirmNewPassword,
      };

      var  result = await AuthorizationRepository.changePassword(
        changePassword
      );
      if (result.data.status === "Success") {
        alert("Password Successfully Changed");
        // eslint-disable-next-line no-console
        console.log(result);
        self.$router.push({ name: "main" });
      } else {
        alert("Id or Password not Correct.  Please Try Again");
      }
    },
  },
};
</script>
